'use client'
import { mergeConfig, TrackerConfig, TrackerProps } from '@avia/tracker'
import { createContext, PropsWithChildren, useCallback, useContext, useMemo } from 'react'

const TrackerContext = createContext<TrackerConfig | null>(null)

export const useTrackerConfig = (defaultConfig?: TrackerConfig) => {
  const ctx = useContext(TrackerContext)

  const config = useMemo(() => {
    const next = ctx || {}
    if (!defaultConfig) {
      return next
    }
    return mergeConfig(next, defaultConfig)
  }, [ctx, defaultConfig])

  // 深层遍历 merge
  const mergeCtx = useCallback(
    (data?: TrackerConfig) => {
      if (!data) {
        return config
      }
      return mergeConfig(config, data)
    },
    [config],
  )

  return [config, mergeCtx] as const
}

export const TrackerProvider = ({ children, config }: PropsWithChildren<TrackerProps>) => {
  const [mergedConfig] = useTrackerConfig(config)
  return <TrackerContext value={mergedConfig}>{children}</TrackerContext>
}
